(function() {
    'use strict';
    angular
        .module('Services')
        .service('TruckInformationAuditService', TruckInformationAuditService);

    function TruckInformationAuditService($http, $rootScope, Error, Request, Shipments, $cacheFactory, $q,$routeParams) {

        var service = {
            getTruckInformationAudit : function (successCallback, errorCallback,data){
                Request.get({
                    url: ApiURLs.fleets.truckDriverInformationAudit,
                    successCallback,
                    errorCallback,
                    data:data
                });
            },
            getTruckLoadInformationAudit : function (successCallback, errorCallback, data){
                var id = $routeParams.driverId
                Request.get({
                    url: ApiURLs.shipment.truckLoadInfomationAudit.replace(':driverId',id),
                    successCallback,
                    errorCallback,
                    data:data
                });
            },
            truckDriverInformationAudit : function(truckData){
                let dataContent=[]
                let data ={
                    empty: truckData.empty,
                    first: truckData.first,
                    last: truckData.last,
                    number: truckData.number,
                    numberOfElements: truckData.numberOfElements,
                    pageable:truckData.pageable,
                    size:truckData.size,
                    sort:truckData.sort,
                    totalElements:truckData.totalElements,
                    totalPages:truckData.totalPages
                }
                angular.forEach(truckData.content, function (item) {
                    let manifestedNo,packageNo ;
                    angular.forEach(item.truckDriverAuditShipmentDetailSet,function(manifest){
                        manifestedNo = manifest.manifestNo;
                    })
                    dataContent.push({
                        id:item.id,
                        DateLoaded: item.createdDate,
                        vehicleId: item.vehicle ? item.vehicle.vehicleId : 'N/A',
                        plateNumber: item.vehicle ? item.vehicle.plateNumber : item.externalVehicleId || 'N/A' ,
                        noOfShipment:item.noOfShipment,
                        driverName: item.driver ? item.driver.firstName +' '+ item.driver.lastName : item.driverName ||'N/A',
                        driverId: item.driver ? item.driver.driverId : 'N/A',
                        driverEmail: item.driver ? item.driver.email :'N/A',
                        driverPhone: item.driver ? item.driver.phone1 : item.driverContact || 'N/A',
                        carrierProfileName:item.carrierProfileName ||'N/A',
                        driverDetails:item,
                        manifestNo: manifestedNo || 'N/A',
                        packageNo:item.noOfPackage || 'N/A'
                    });
                });
                data.content = dataContent
                return data

            },
            truckLoadInfomationAuditData:function(truckloadData){
                let data =[]
                let truckData =[]
                angular.forEach(truckloadData, function (item) {
                    truckData.push({
                        createdDate: item.createdDate,
                        consignmentNo:item.consignmentId,
                        manifestNo:item.manifestNo,
                        company:item.companyName,
                        officeLocation:item.officeName,
                        account:item.sourceAddress.email,
                        bookingStatus:item.bookingStatus,
                        trackingNo:item.trackingNumber,
                        thirdPartyReferenceNo:item.customerReferences,
                        customerRefNo:item.customerReferences,
                        linkedJob:item.linkedJobId,
                        AmountExTax:item.amount,
                        shipmentId:item.id,
                        destinationAddress: item.destinationAddress,
                        sourceAddress: item.sourceAddress,
                        containerCodes:item.containerCodes
                    })
                });
                data.content = truckData

                return data;
            }

        };
        return service;
    };

})();



// WEBPACK FOOTER //
// ./js/services/TruckInformationAuditService.js